import directions from 'components/configurator/types/directions';
import IWall from 'components/interfaces/IWall';
import { GLASS_WALL } from 'components/configurator/types/wallTypes';

import { BLACK_SILICON } from '../types/glassJointTypes';
import { GLASS_TYPE_1076 } from '../types/glassTypes';
import { RIGHT as DIMENSION_SIDE_RIGHT } from '../types/dimensionSides';
import { RIGHT as DOOR_HANG_RIGHT } from '../types/doorHangTypes';
import { SE0004 as ROOF_PROFILE_SE0004 } from '../types/roofProfileTypes';
import { SE0134 as FLOOR_PROFILE_SE0134 } from '../types/floorProfileTypes';
import { SE0134 as VERTICAL_PROFILE_SE0134 } from '../types/verticalProfileTypes';
import { SLIDY_30 } from '../types/glazingWallTypes';

const getDefaultWall = (): IWall => ({
  // Wall properties
  AluDoorRoofOffset: 15,
  buildingWallColor: 'NCS(0505-R70B)',
  dimensionSide: DIMENSION_SIDE_RIGHT,
  endAngle: 0,
  length: 4000,
  perpendicularConnectionEnd: false,
  perpendicularConnectionStart: false,
  roofHeight: 3500,
  startAngle: 0,
  thickness: 118,
  wallDirection: directions[0],
  wallType: GLASS_WALL,
  // Glass wall properties
  addCornerPlate2k: false,
  aluDoorIn2kOffset: 7,
  aluGlazyFloorProfileType: FLOOR_PROFILE_SE0134,
  aluGlazyRoofProfileType: ROOF_PROFILE_SE0004,
  doorGlassIds: {
    primaryGlassId: '1',
    aboveGlassId: '2',
    secondaryGlassId: '3',
    sideGlassLeftId: '4',
    sideGlassRightId: '5',
  },
  doorGlassNames: {
    primaryGlassName: '',
    aboveGlassName: '',
    secondaryGlassName: '',
    sideGlassLeftName: '',
    sideGlassRightName: '',
  },
  doorGlassType: '-',
  doorHang: DOOR_HANG_RIGHT,
  doorHeight: 2100,
  doorOpeningWidth: 0,
  doorLeafDirection: 'inward',
  doorPosition: 1000,
  doorSide: 'inside',
  doorType: '-',
  floorOffset: 0,
  floorProfileWithColor: false,
  glassJoint: BLACK_SILICON,
  glassList: '-',
  glassType: GLASS_TYPE_1076,
  glazingWallType: SLIDY_30,
  glazyDoubleWidth: 100,
  glazyDoubleGlassType: 'glass',
  glazyDoubleSpecialPos: 'first',
  glazyDoubleSpecialHeight: 1000,
  glazyDoubleSpecialColor: 'RAL 5003',
  handleHeight: 1100,
  handleType: 'default',
  hasLock: false,
  hasOpenRoof: false,
  leftVerticalProfileType: VERTICAL_PROFILE_SE0134,
  leftWallOffset: 0,
  listColor: '',
  onlyDoor: false,
  openingHeight: 1500,
  parts: [],
  positionOffset: 0,
  profileColor: 'RAL 9003',
  rightVerticalProfileType: VERTICAL_PROFILE_SE0134,
  rightWallOffset: 0,
  roofProfileOffset: 5,
  roofType: '',
  showOpenDoors: false,
  wallName: '',
  woodyLeftGlassDepth: 6,
  woodyRightGlassDepth: 6,
  woodyFloorGlassDepth: 6,
  woodyFloorProfileOffset: 0,
  woodyRoofGlassDepth: 6,
  woodyProfileWidth: 92,
  woodyGlassOffset: 20,
  hProfileLeftOffset: 0,
  woodyRoofProfileOffset: 10,
  hProfileRightOffset: 0,
  woodyLeftProfileHeight: 25,
  woodyRightProfileHeight: 25,
  woodyFloorProfileHeight: 25,
  woodyLeftGrooveDepth: 8,
  woodyRightGrooveDepth: 8,
  woodyFloorGrooveDepth: 8,
  woodyRoofGrooveDepth: 8,
  woodyLeftGlassGroove: true,
  woodyLeftGuideGroove: false,
  woodyLeftBackGroove: true,
  woodyRightGlassGroove: true,
  woodyRightGuideGroove: false,
  woodyRightBackGroove: true,
  woodyFloorGlassGroove: true,
  woodyFloorGuideGroove: false,
  woodyFloorBackGroove: true,
  woodyRoofGlassGroove: true,
  woodyRoofGuideGroove: true,
  woodyRoofBackGroove: false,
  woodyQuantityDecorList: 0,
  woodyHeightDecorList: 40,
  woodyThicknessOutsideDecorList: 20,
  woodyThicknessInsideDecorList: 55,
  woodySingleHeightDecorList: 900,
  woodyDoorLeafColor: '',
  woodyDoorFrameColor: '',
  woodyDoorFrameDepth: 92,
  woodyIncludeWoodenLists: false,
  woodyIncludeWoodyLeftProfile: false,
  leftStandingWoodyProfileHeight: 42,
  woodyIncludeWoodyRightProfile: false,
  rightStandingWoodyProfileHeight: 42,
  woodyRoofProfileHeight: 25,
  hasLeftDoorPrimary: false,
  primaryDoorWidth: 0,
  hasSolidSlaveDoor: false,
  doorOffsetLeft: 10,
  doorOffsetRight: 10,
  // From here they are hardcoded fields not included in the form
  floorThicknessOffset: 0,
  includeCeiling: false,
  insideCeilingHeight: '3000',
  leftSideGlassWidth: 250,
  outsideCeilingHeight: '3000',
  woodyHingeType: 'default',
});

export default getDefaultWall;
